import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import LogoModal from '../assets/icons/LogoModal.svg';
import ContactModal from './ContactModal';

const modalOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.7)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000,
  transition: 'opacity 0.2s ease-in-out',
};

const modalButtonStyle = {
  padding: '0.5rem 1rem',
  backgroundColor: '#7ebcec',
  color: 'white',
  border: 'none',
  borderRadius: '50px',
  cursor: 'pointer',
  fontWeight: 'normal',
  fontSize: '1em',
};

const AboutModal = ({ show, onClose }) => {
  const { t } = useTranslation();
  const [showContact, setShowContact] = useState(false);
  const scrollRef = useRef(null);
  useEffect(() => {
    if (!show) {
      setShowContact(false);
      return;
    }
    const timer = setTimeout(() => {
      if (scrollRef.current) scrollRef.current.scrollTop = 0;
    }, 0);
    return () => clearTimeout(timer);
  }, [show]);
  const currentOverlayStyle = {
    ...modalOverlayStyle,
    opacity: show ? 1 : 0,
    pointerEvents: show ? 'auto' : 'none',
  };
  const outerStyle = {
    position: 'relative',
    backgroundColor: 'white',
    borderRadius: '0.625rem',
    width: '90vw',
    maxWidth: '42rem',
    maxHeight: '85vh',
    overflow: 'hidden',
    boxShadow: '0 0.25rem 0.625rem rgba(0, 0, 0, 0.2)',
    transform: show ? 'scale(1)' : 'scale(0.8)',
    transition: 'transform 0.2s ease-in-out',
  };
  const scrollStyle = {
    maxHeight: '85vh',
    overflowY: 'auto',
    padding: '3rem 3rem 5.5rem',
    textAlign: 'left',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    boxSizing: 'border-box',
  };
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };
  const headingStyle = {
    fontFamily: 'Effra',
    fontWeight: 400,
    fontSize: '1.25rem',
    color: '#4d4d4d',
    margin: '0.9rem 0 0',
  };
  const paragraphStyle = {
    fontFamily: 'Effra',
    fontWeight: 300,
    fontSize: '1.05rem',
    lineHeight: 1.6,
    color: '#4d4d4d',
    margin: 0,
  };
  const sections = t('aboutModal.sections', { returnObjects: true });
  return (
    <>
      <div style={currentOverlayStyle} onClick={handleOverlayClick}>
        <div style={outerStyle}>
          <div
            onClick={onClose}
            style={{
              position: 'absolute',
              top: '1rem',
              right: '1rem',
              zIndex: 2,
              cursor: 'pointer',
              display: 'flex',
              color: '#4d4d4d',
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              style={{ width: '1.5rem', height: '1.5rem' }}
            >
              <path
                fillRule="evenodd"
                d="M5.47 5.47a.75.75 0 011.06 0L12 10.94l5.47-5.47a.75.75 0 111.06 1.06L13.06 12l5.47 5.47a.75.75 0 11-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 01-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 010-1.06z"
                clipRule="evenodd"
              />
            </svg>
          </div>
          <div ref={scrollRef} className="about-modal-scroll" style={scrollStyle}>
            <h2
              style={{
                fontFamily: 'Effra',
                fontWeight: 600,
                fontSize: '1.6rem',
                margin: 0,
                color: '#4d4d4d',
                textAlign: 'center',
              }}
            >
              {t('aboutModal.title')}
            </h2>
            <p style={{ ...paragraphStyle, fontStyle: 'italic', textAlign: 'left', maxWidth: '95%' }}>
              {t('aboutModal.intro')}
            </p>
            {Array.isArray(sections) &&
              sections.map((section, i) => (
                <div key={i} style={{ display: 'flex', flexDirection: 'column', gap: '0.65rem' }}>
                  <h3 style={headingStyle}>{section.heading}</h3>
                  {section.paragraphs.map((par, j) => (
                    <p key={j} style={paragraphStyle}>
                      {par}
                    </p>
                  ))}
                </div>
              ))}
            <button
              type="button"
              onClick={() => setShowContact(true)}
              style={{ ...modalButtonStyle, alignSelf: 'flex-start', marginTop: '0.4rem' }}
            >
              {t('aboutModal.contact.title')}
            </button>
            <p style={{ ...paragraphStyle, marginTop: '0.6rem' }}>{t('aboutModal.thanks')}</p>
          </div>
          <div
            style={{
              position: 'absolute',
              left: 0,
              right: 0,
              bottom: 0,
              height: '4rem',
              background: 'linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,1))',
              pointerEvents: 'none',
            }}
          />
        </div>
      </div>
      <ContactModal show={showContact} onClose={() => setShowContact(false)} />
    </>
  );
};

export default AboutModal;
